import {BrowserRouter, Routes, Route, Navigate} from 'react-router-dom';
import { useState } from 'react';


import './css/forms.css'
import './css/typo.css'
import './css/admin/grid.css'
import './css/main.css'

import ScrollToTop from './components/scrollTop';

import PublicLayout from './layouts/public';
import PublicDashboardLayout from './layouts/dashboard';
import PublicHome from './pages/public/home';
import PublicKaayCloset from './pages/public/kaaycloset';
import PublicNewonkaay from './pages/public/newonkaay';
import PublicArtnCraft from './pages/public/artncraft';
import PublicLogin from './v2/pages/public/login';
import PublicRegister from './v2/pages/public/signup';
import PublicAbout from './pages/public/about';
import PublicSellonkaay from './pages/public/sellonkaay';
import PublicUser from './pages/public/user';
import PublicEditprofile from './pages/public/editprofile';
import PublicUserListing from './pages/public/listing';
import PublicUserListingadd from './pages/public/listing/add';
import PublicUserListingCreate from './pages/public/dashboard/product/create'
import PublicListing from './components/public/product';
import PublicCollection from './pages/public/collection';
import PublicNcollection from './pages/public/ncollection';
import PublicStateList from './pages/public/statelist';
import PublicBrandmap from './pages/public/brandmap';
import PublicCollectionmap from './pages/public/collectionmap';
import PublicDashboard from './pages/public/dashboard';
import PublicBookmarkList from './pages/public/bookmarklist';
import PublicLikedList from './pages/public/likedlist';
import PublicSales from './pages/public/sales';
import PublicSearch from './pages/public/search/index';
import PublicSearchMain from './pages/public/searchmain';
import PublicInsights from './pages/public/insights';
import PublicChangepassword from './pages/public/changepassword';
import PublicHastag from './pages/public/hastag/index';
import PublicListingedit from './pages/public/listingedit';
import PublicOrders from './pages/public/orders'
import PublicOrderView from './pages/public/orders/view'
import PublicNotifications from './pages/public/notifications';
import PublicFaq from './pages/public/faq';
import PublicBrandlisting from './pages/public/brandlisting';
import PublicPrivacypolicy from './pages/public/privacypolicy';
import PublicHelp from './pages/public/help';
import PublicFilter from './pages/public/filter';
import PublicChat from './pages/public/dashboard/chat';


import PublicSellerpolicies from './layouts/sellerpolicies';
import PuclicSellerpoliciesIndex from './pages/public/sellerpolicies';
import PublicAccount_suspension_penalties from './pages/public/sellerpolicies/account_suspension_penalties';
import PublicAdvertisements_on_the_service from './pages/public/sellerpolicies/advertisements_on_the_service';
import PublicCommission_structure from './pages/public/sellerpolicies/commission_structure';
import PublicConflict_resolution from './pages/public/sellerpolicies/conflict_resolution';
import PublicData_collection_from_seller from './pages/public/sellerpolicies/data_collection_from_seller';
import PublicDiscount_policy from './pages/public/sellerpolicies/discount_policy';
import PublicIndemnification from './pages/public/sellerpolicies/indemnification';
import PublicIntellectual_property from './pages/public/sellerpolicies/intellectual_property';
import PublicMisleading_information from './pages/public/sellerpolicies/misleading_information';
import PublicPackaging_guidelines from './pages/public/sellerpolicies/packaging_guidelines';
import PublicParcel_order_lost from './pages/public/sellerpolicies/parcel_order_lost';
import PublicPayment_policy from './pages/public/sellerpolicies/payment_policy';
import PublicPr_gifting from './pages/public/sellerpolicies/pr_gifting';
import PublicRequirments_for_registration from './pages/public/sellerpolicies/requirments_for_registration';
import PublicReturn_and_replacement from './pages/public/sellerpolicies/return_and_replacement';
import PublicSeller_information from './pages/public/sellerpolicies/seller_information';
import PublicSeller_obligations_to_customer_service from './pages/public/sellerpolicies/seller_obligations_to_customer_service';
import PublicSeller_performance from './pages/public/sellerpolicies/seller_performance';
import PublicShipping_and_order_fulfilment from './pages/public/sellerpolicies/shipping_and_order_fulfilment';
import PublicShipping from './pages/public/sellerpolicies/shipping';
import PublicTaxes from './pages/public/sellerpolicies/taxes';
import PublicTermination_and_duration from './pages/public/sellerpolicies/termination_and_duration';
import PublicYour_product_listings_featuring from './pages/public/sellerpolicies/your_product_listings_featuring';

import PublicAmendments from './pages/public/sellerpolicies/amendments';
import PublicContact from './pages/public/sellerpolicies/contact';
import PublicCopyright from './pages/public/sellerpolicies/copyright';
import PublicDelivery_and_cancellations from './pages/public/sellerpolicies/delivery_and_cancellations';
import PublicExchange_policy from './pages/public/sellerpolicies/exchange_policy';
import PublicIntellectual_property_rights from './pages/public/sellerpolicies/intellectual_property';
import PublicKaay_closet from './pages/public/sellerpolicies/kaay_closet';
import PublicOur_contract from './pages/public/sellerpolicies/our_contract';
import PublicPayment from './pages/public/sellerpolicies/payment';
import PublicPersonal_information from './pages/public/sellerpolicies/personal_information';
import PublicPricing_and_availability from './pages/public/sellerpolicies/pricing_and_availability';
import PublicPrivacy_policy from './pages/public/sellerpolicies/privacy_policy';
import PublicProduct from './pages/public/sellerpolicies/product';
import PublicRetention_of_title from './pages/public/sellerpolicies/retention_of_title';
import PublicScam from './pages/public/sellerpolicies/scam';
import PublicTermination from './pages/public/sellerpolicies/termination';
import PublicUser_content from './pages/public/sellerpolicies/user_content';



import AdminLayout from './layouts/admin/index';
import AdminLayoutTitle from './layouts/admin/title';
import AdminIndex from './pages/admin/index';
import AdminCategory from './pages/admin/category/index';
import AdminCategoryadd from './pages/admin/categoryadd';
import AdminCategoryedit from './pages/admin/categoryedit';
import AdminColor from './pages/admin/color/index';
import AdminBrand from './pages/admin/brand';
import AdminCondition from './pages/admin/condition';
import AdminIntrust from './pages/admin/intrust';
import AdminProductType from './pages/admin/producttype';
import AdminUser from './pages/admin/user';
import AdminUserView from './pages/admin/user/view';
import AdminLocation from './pages/admin/location';
import AdminMenu from './pages/admin/menu/index';
import AdminMenuadd from './pages/admin/menuadd';
import AdminMenuedit from './pages/admin/menuedit';
import AdminPages from './pages/admin/pages';
import AdminPage1 from './pages/admin/pagesedit/home/index';
import AdminPage2 from './pages/admin/pagesedit/ios/index';
import AdminPage3 from './pages/admin/pagesedit/iosSearch';
import AdminFiles from './pages/admin/files';
import AdminOrders from './pages/admin/orders';
import AdminOrderView from './pages/admin/orders/view';
import AdminListing from './pages/admin/listing';
import AdminEditListing from './pages/admin/listing/edit';
import AdminCollection from './pages/admin/collection/index';
import AdminTickets from './pages/admin/tickets';
import AdminDiscountCodes from './pages/admin/discountCodes';

import Checkout from './pages/public/checkout';


function App() {
  const [homeSwitch,setHomeSwitch] = useState(0);
  const [openChatBox,setOpenChatBox] = useState({
    id:0,
    userid:0,
    userimage:"",
    username:"",
    first:"",
    last:"",
    isUserA:false
  });
  return (
    <BrowserRouter>
      <ScrollToTop>
      <Routes>
        <Route path='checkout' element={<Checkout/>}/>
        <Route path='/' element={ <PublicLayout HomeSwitch={homeSwitch} SetHomeSwitch={setHomeSwitch} openChatBox={openChatBox} setOpenChatBox={setOpenChatBox}/> }>
          <Route index element = { <PublicHome HomeSwitch={homeSwitch} SetHomeSwitch={setHomeSwitch}/> } />
          <Route path='kaay-closet' element = {<PublicKaayCloset />} />
          <Route path='new-on-kaay' element = {<PublicNewonkaay />} />
          <Route path='art-and-lifestyle' element = {<PublicArtnCraft />} />
          <Route path='login' element = {<PublicLogin/>} />
          <Route path='signup' element = {<PublicRegister/>} />
          <Route path='faq' element = {<PublicFaq />} />
          <Route path='notifications' element={<PublicNotifications/>}/>
          <Route path='story' element = {<PublicAbout/>} />
          <Route path='sellonkaay' element = {<PublicSellonkaay/>} />
          <Route path='brandmap' element = {<PublicBrandmap/>} />
          <Route path='sellingmap' element = {<PublicCollectionmap/>} />
          <Route path='filter' element = {<PublicFilter/>} />
          <Route path='user/:username' element = {<PublicUser />} />
          <Route path='collection/:id' element = {<PublicCollection/>} />
          <Route path='ncollection/:id' element = {<PublicNcollection/>} />
          <Route path='product/:slug' element = {<PublicListing setOpenChatBox={setOpenChatBox} />} />
          <Route path='statelist/:id' element = {<PublicStateList/>} />
          <Route path='mobilesearch' element = {<PublicSearchMain/>} />
          <Route path='search' element = {<PublicSearch/>} />
          <Route path='hashtag/:value' element = {<PublicHastag/>} />
          <Route path='brand/:value' element = {<PublicBrandlisting/>} />
          <Route path='dashboard' element={<PublicDashboardLayout />}>
            <Route index element={<Navigate to='/dashboard/index'/>}/>
            <Route path='index' element={<PublicDashboard />}/>
            <Route path='editprofile' element={<PublicEditprofile />}/>
            <Route path='bookmarks' element={<PublicBookmarkList/>}/>
            <Route path='liked' element={<PublicLikedList/>}/>
            <Route path='messages' element={<PublicChat/>}/>
            <Route path='orders' element={<PublicOrders/>}/>
            <Route path='orders/view/:id' element={<PublicOrderView/>}/>
            <Route path='sales' element={<PublicSales/>}/>
            <Route path='insights' element={<PublicInsights />}/>
            <Route path='listings'>
              <Route index element={<PublicUserListing />}/>
              <Route path='add' element={<Navigate to='/dashboard/listings/create'/>}/>
              <Route path='create' element={<PublicUserListingCreate />}/>
              <Route path='edit/:value' element={<PublicListingedit />}/>
            </Route>
            <Route path='changepassword' element={<PublicChangepassword />}/>
            <Route path='help' element={<PublicHelp />}/>
          </Route>
          <Route path='privacypolicy' element = {<PublicPrivacypolicy/>} />
          <Route path='policies' element={<PublicSellerpolicies />}>
            <Route index element={<PuclicSellerpoliciesIndex/>}/>
            <Route path='account_suspension_penalties' element={<PublicAccount_suspension_penalties/>}/>
            <Route path='advertisements_on_the_service' element={<PublicAdvertisements_on_the_service/>}/>
            <Route path='commission_structure' element={<PublicCommission_structure/>}/>
            <Route path='conflict_resolution' element={<PublicConflict_resolution/>}/>
            <Route path='data_collection_from_seller' element={<PublicData_collection_from_seller/>}/>
            <Route path='discount_policy' element={<PublicDiscount_policy/>}/>
            <Route path='indemnification' element={<PublicIndemnification/>}/>
            <Route path='intellectual_property' element={<PublicIntellectual_property/>}/>
            <Route path='misleading_information' element={<PublicMisleading_information/>}/>
            <Route path='packaging_guidelines' element={<PublicPackaging_guidelines/>}/>
            <Route path='parcel_order_lost' element={<PublicParcel_order_lost/>}/>
            <Route path='payment_policy' element={<PublicPayment_policy/>}/>
            <Route path='pr_gifting' element={<PublicPr_gifting/>}/>
            <Route path='requirments_for_registration' element={<PublicRequirments_for_registration/>}/>
            <Route path='return_and_replacement' element={<PublicReturn_and_replacement/>}/>
            <Route path='seller_information' element={<PublicSeller_information/>}/>
            <Route path='seller_obligations_to_customer_service' element={<PublicSeller_obligations_to_customer_service/>}/>
            <Route path='seller_performance' element={<PublicSeller_performance/>}/>
            <Route path='shipping_and_order_fulfilment' element={<PublicShipping_and_order_fulfilment/>}/>
            <Route path='shipping' element={<PublicShipping/>}/>
            <Route path='taxes' element={<PublicTaxes/>}/>
            <Route path='termination_and_duration' element={<PublicTermination_and_duration/>}/>
            <Route path='your_product_listings_featuring' element={<PublicYour_product_listings_featuring/>}/>

            <Route path='amendments' element={<PublicAmendments/>}/>
            <Route path='contact' element={<PublicContact/>}/>
            <Route path='copyright' element={<PublicCopyright/>}/>
            <Route path='delivery_and_cancellations' element={<PublicDelivery_and_cancellations/>}/>
            <Route path='exchange_policy' element={<PublicExchange_policy/>}/>
            <Route path='intellectual_property_rights' element={<PublicIntellectual_property_rights/>}/>
            <Route path='kaay_closet' element={<PublicKaay_closet/>}/>
            <Route path='our_contract' element={<PublicOur_contract/>}/>
            <Route path='payment' element={<PublicPayment/>}/>
            <Route path='personal_information' element={<PublicPersonal_information/>}/>
            <Route path='pricing_and_availability' element={<PublicPricing_and_availability/>}/>
            <Route path='privacy_policy' element={<PublicPrivacy_policy/>}/>
            <Route path='product' element={<PublicProduct/>}/>
            <Route path='retention_of_title' element={<PublicRetention_of_title/>}/>
            <Route path='scam' element={<PublicScam/>}/>
            <Route path='termination' element={<PublicTermination/>}/>
            <Route path='user_content' element={<PublicUser_content/>}/>
          </Route>
        </Route>
        <Route path='/admin' element={<AdminLayout />}>
          <Route index element={<Navigate to='/admin/dashboard'/>}/>
          <Route path='dashboard' element={<AdminLayoutTitle/>}>
            <Route index element={<AdminIndex/>}/>
          </Route>
          <Route path='products' element={<AdminLayoutTitle/>}>
            <Route index element={<Navigate to='/admin/products/category'/>}/>
            <Route path='category' element={<AdminCategory/>}/>
            <Route path='category/add' element={<AdminCategoryadd/>}/>
            <Route path='category/edit/:id' element={<AdminCategoryedit/>}/>
            <Route path='color' element={<AdminColor/>}/>
            <Route path='brand' element={<AdminBrand/>}/>
            <Route path='condition' element={<AdminCondition/>}/>
            <Route path='type' element={<AdminProductType/>}/>
            <Route path='listing/:active' element={<AdminListing/>}/>
            <Route path='listing/edit/:value' element={<AdminEditListing />}/>
            <Route path='collection' element={<AdminCollection/>}/>
          </Route>
          <Route path='orders' element={<AdminLayoutTitle/>}>
            <Route index element={<Navigate to='/admin/orders/list'/>}/>
            <Route path='list' element={<AdminOrders/>}/>
            <Route path='view/:id' element={<AdminOrderView/>}/>
            <Route path='discountcodes' element={<AdminDiscountCodes/>}/>
          </Route>
          <Route path='algorithm' element={<AdminLayoutTitle/>}>
            <Route index element={<Navigate to='/admin/algorithm/intrust'/>}/>
            <Route path='intrust' element={<AdminIntrust/>}/>
          </Route>
          <Route path='user' element={<AdminLayoutTitle/>}>
            <Route index element={<Navigate to='/admin/user/list'/>}/>
            <Route path='list' element={<AdminUser/>}/>
            <Route path='view/:username' element={<AdminUserView/>}/>
            <Route path='location' element={<AdminLocation/>}/>
            <Route path='tickets' element={<AdminTickets/>} />
          </Route>
          <Route path='onlinestore' element={<AdminLayoutTitle/>}>
            <Route index element={<Navigate to='/admin/onlinestore/navigation'/>}/>
            <Route path='navigation' element={<AdminMenu/>}/>
            <Route path='navigation/add' element={<AdminMenuadd/>}/>
            <Route path='navigation/edit/:id' element={<AdminMenuedit/>}/>
            <Route path='pages' element={<AdminPages/>}/>
            <Route path='pages/edit/1' element={<AdminPage1/>}/>
            <Route path='pages/edit/2' element={<AdminPage2/>}/>
            <Route path='pages/edit/3' element={<AdminPage3/>}/>
          </Route>
          <Route path='files' element={<AdminLayoutTitle/>}>
            <Route index element={<AdminFiles/>}/>
          </Route>
        </Route>
      </Routes>
      </ScrollToTop>
    </BrowserRouter>
  );
}

export default App;
